import * as Yup from 'yup';

export const vehicleValidationSchema = Yup.object().shape({
  marca: Yup.string()
    .required('Marca é obrigatória')
    .min(2, 'Marca deve ter no mínimo 2 caracteres')
    .max(50, 'Marca deve ter no máximo 50 caracteres'),
  
  modelo: Yup.string()
    .required('Modelo é obrigatório')
    .min(2, 'Modelo deve ter no mínimo 2 caracteres')
    .max(50, 'Modelo deve ter no máximo 50 caracteres'),
  
  tipo: Yup.string()
    .required('Tipo é obrigatório')
    .oneOf(['carro', 'moto', 'caminhao', 'outro'], 'Tipo inválido'),
  
  placa: Yup.string()
    .required('Placa é obrigatória')
    .matches(
      /^[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/,
      'Placa deve estar no formato Mercosul (ABC1D23) ou antigo (ABC1234)'
    ),
  
  ano: Yup.number()
    .min(1900, 'Ano inválido')
    .max(new Date().getFullYear() + 1, 'Ano não pode ser maior que o atual')
    .required('Ano é obrigatório'),
  
  cor: Yup.string()
    .required('Cor é obrigatória')
    .min(2, 'Cor deve ter no mínimo 2 caracteres')
    .max(30, 'Cor deve ter no máximo 30 caracteres'),
  
  observacoes: Yup.string()
    .max(500, 'Observações deve ter no máximo 500 caracteres')
    .optional(),
  
  foto: Yup.array()
    .max(1, 'Apenas uma foto é permitida')
    .optional(),
}); 